import React from "react";
import InsurancePresenter from "./InsurancePresenter";
import Shell from "../../../common/components/Shell/Shell";
import { Grid } from "@mui/material";
import DTOInsurance from "./DTOInsurance";
import { useTranslation } from "react-i18next";

function InsuranceController() {
  const { t, i18n } = useTranslation();

  return (
    <Shell>
      <Grid
        container
        style={{
          maxWidth: "auto",
          marginLeft: i18n.language == "en" ? "7.25em" : "",
        }}
      >
        <DTOInsurance />
        <InsurancePresenter trans={t} i18n={i18n} />
      </Grid>
    </Shell>
  );
}
export default InsuranceController;
